/** Tipo de documento brasileiro identificado após normalização. */
export type BrazilianDocumentKind = 'cpf' | 'cnpj' | 'unknown';

/** Tamanhos do corpo do documento (sem pontuação). */
export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;
export const CNPJ_BASE_LENGTH = 12;
